const BaseRandomizer = require('./base');

class SimpleRandomization extends BaseRandomizer {
  constructor() {
    super('simple', 'Simple Randomization (Bernoulli)');
  }

  randomize(rng, params) {
    const sequence = [];

    for (let i = 0; i < params.n; i += 1) {
      const armIndex = Math.floor(rng() * params.arms);
      sequence.push(this.buildAssignment(i, armIndex));
    }

    return sequence;
  }

  getExplanation() {
    return `
      <h3>Simple Randomization (Bernoulli)</h3>
      <p>Each participant is assigned independently with equal probability to each study arm.</p>
      <pre>For patient i in 1..N:
  arm[i] = floor(random(seed) * number_of_arms)</pre>
      <p>This method is maximally unpredictable, but small samples can show visible imbalance by chance.</p>
    `;
  }
}

module.exports = SimpleRandomization;
